import React, {useEffect, useRef, useState} from 'react';
import "../Store/Store.scss";
import "./Service.scss";
import SimpleLineIcon from "react-simple-line-icons";
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import {Nav} from "../../Components";
import {useHistory, useLocation} from "react-router-dom";
import {ServiceList_api, ServiceTags_api} from "./ServiceServices";
import {Spin} from "antd";


let globSearch = "";

function StoreCard({item}) {

    const history = useHistory();

    const gotToDetail = merchant => history.push(`/service-detail/${item.uid}`, {merchant})

    const limitText = (t) => {
        if (t.length > 0)
            return t.substr(0, 40) + "..."
        else
            return ''
    }


    return (
        <div className="blog-item" onClick={() => gotToDetail(item)}>
            <div className="blog-item-img">
                <img src={item.cover} alt=""/>
                {/*<img src="https://s3.mobank.co/loyalty-media/blog_post/blog_post/images/%D8%A8%D9%88%D8%AA%D8%A7%DA%A9%D8%B3_e7MGBjJ_qjypGnW.png" alt=""/>*/}
            </div>
            <div className="blog-item-info">
                <div className="blog-item-title">
                    {item.title}
                </div>
                <div className="blog-item-desc">
                    {limitText(item.body)}
                </div>
            </div>
        </div>

        // <div style={{position: 'relative'}} >
        //     <div key={item.uid} className="store-item" onClick={()=>gotToDetail(item)}>
        //         <div className="store-item-info">
        //             <span className="store-item-name">{item.title}</span>
        //             <span className="store-item-cat">{item.subtitle}</span>
        //         </div>
        //         <div className="store-item-img">
        //             <img src={item.cover} alt=""/>
        //         </div>
        //     </div>
        // </div>
    )
}


function Service() {



    const MyRef = useRef(null);
    const location = useLocation()


    const params = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        // rebuildOnUpdate : true,
        rtl: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const [preload, setPreload] = useState(true);
    const [spin, setSpin] = useState(false);
    const [failed, setFailed] = useState(false);
    const [search, set_search] = useState("");

    const [cats, setCats] = useState([])
    const [originalList, setOriginalList] = useState([])
    const [list, setList] = useState([])
    const [currentCat, set_currentCat] = useState([])
    const [nav_label, set_nav_label] = useState(null)

    useEffect(() => {
        if (location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    }, [])


    const updateSlider = () => {
        MyRef.current.swiper.update();
    }

    const getStore = async (tagId = null) => {
        // setPreload(true);
        setSpin(true)
        try {
            const res = await ServiceList_api(tagId, globSearch)
            setList(res.data)
            updateSlider();
            setPreload(false);
            setSpin(false)
        } catch (e) {
            setSpin(false)
            setPreload(false);
        }
    }


    const getCat = async () => {
        try {
            const response = await ServiceTags_api();
            setCats(response.data);
            setPreload(false);

            if (location.state && location.state.tagLink) {
                console.log("Tag LINK : ", location.state.tagLink)
                selectCat(location.state.tagLink)
            } else {
                selectCat({uid: 1})
            }
        } catch (e) {
            setPreload(false);
        }
    }

    const selectCat = (tag) => {
        set_currentCat(tag)
        if (tag.uid !== 1)
            getStore(tag.uid)
        else
            getStore()
    }


    useEffect(() => {
        getStore()
        getCat();
    }, [])

    const calcTextWidth = (text) => {
        let length = text.length;
        if (length < 4)
            return length * 15

        if (length > 10)
            return length * 8;

        return length * 12
    }


    const newParams = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        rtl: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }

    const doSearch = (word) => {
        set_search(word);
        globSearch = word;


        try {
            getStore()
        } catch (e) {
            console.error(e)
        }
    }

    const [timer, setTimer] = useState(null);
    const changeDelay = (change)=> {
        set_search(change);
        globSearch = change;
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                // console.log(change);
                getStore()
            }, 1000)
        );
    }

    return (
        <div className="store-container">
            {/*Header*/}
            <div className="customer-header">
                <span>{nav_label ? nav_label : "خدمات"}</span>
            </div>
            <div className="store-head">

                <div className="blog-search-box-sec">
                    <div className="blog-search-box">
                        <input
                            value={search}
                            placeholder="جستجو"
                            // onChange={e => doSearch(e.target.value)}
                            onChange={(e) => { changeDelay(e.target.value); }}
                            type="text" name="" id=""/>
                        <SimpleLineIcon style={{fontSize: 21, margin: "0 9px"}} name="magnifier"/>
                    </div>
                </div>

                <div className="store-categories-ser">

                    {cats.length > 0 ? <Swiper {...newParams}>
                        <div key={1} onClick={() => {
                            selectCat({uid: 1})
                        }} style={{width: calcTextWidth("همه")}}
                             className={currentCat.uid === 1 ? "slide-a" : "slide-deselect-a"}>
                            همه
                        </div>
                        {cats.map(cat => {
                            return (
                                <div key={cat.uid} onClick={() => {
                                    selectCat(cat)
                                }} style={{width: calcTextWidth(cat.name)}}
                                     className={currentCat.uid === cat.uid ? "slide-a" : "slide-deselect-a"}>
                                    {cat.name}
                                </div>
                            )
                        })}
                    </Swiper> : null}
                </div>

                {/*<div className="store-categories">*/}
                {/*    /!*OnlineStoreSubCat List*!/*/}
                {/*    <div className="store-categories-list">*/}
                {/*        {cats.length>0?  <Swiper ref={MyRef}  {...params}>*/}
                {/*            <div key={1}*/}
                {/*                 onClick={()=>{selectCat({uid:1})}}*/}
                {/*                 className="store-categories-item">*/}
                {/*                    <span className={currentCat.uid===1?"cat_select":"cat_deselect"}>همه*/}
                {/*                        /!*<i className="fa fa-user"></i>*!/*/}
                {/*                    </span>*/}
                {/*                <img src={"https://s3.mobank.co/loyalty-media/merchant/category/images/poshak.png"}  alt="" style={{width:'100%'}}/>*/}
                {/*            </div>*/}
                {/*            {cats.map(cat=>{*/}
                {/*                return (*/}
                {/*                    <div key={cat.uid}*/}
                {/*                         onClick={()=>{selectCat(cat)}}*/}
                {/*                         className="store-categories-item">*/}
                {/*                    <span className={currentCat.uid===cat.uid?"cat_select":"cat_deselect"}>{cat.name}*/}
                {/*                        /!*<i className="fa fa-user"></i>*!/*/}
                {/*                    </span>*/}
                {/*                        <img src={cat.image}  alt="" style={{width:'100%'}}/>*/}
                {/*                    </div>*/}
                {/*                )*/}
                {/*            })}*/}
                {/*        </Swiper>:null}*/}
                {/*    </div>*/}
                {/*</div>*/}


            </div>

            <div className="store-body">
                {/* OnStore List*/}
                {/*{!preload?<div className="store-list" style={{paddingBottom:100}}>*/}
                {!preload ?
                    <Spin spinning={spin}>
                        <div className="blog-list" style={{paddingBottom: 100}}>
                            {list.map(item => {
                                return <StoreCard key={item.uid} item={item}/>;
                            })}
                        </div>
                    </Spin>
                    : <div className="customer-preLoading">
                        {!failed ? <div className="customer-preloading-body">
                            <img src="/svg/pre.gif" alt=""/>
                        </div> : <div className="customer-failed-body">
                            <img src="/svg/failed.svg" alt=""/>
                            <span>اطلاعاتی موجود نیست</span>
                        </div>}
                    </div>}
            </div>
            <Nav/>
        </div>
    )
}

export {Service};
